import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import { AppModule } from './app/app.module';
import './app/transport/gmap-api-logger'; // registers GmapApiLogger on window at startup


platformBrowserDynamic().bootstrapModule(AppModule)
  .catch(err => console.error(err));
